module.exports = __webpack_public_path__ + "static/media/Storyboard1_1.069855de.jpg";